module.exports = __webpack_public_path__ + "img/ar-nft-bg.db3732d7.png";